import checkoutStepBase from '../checkoutStepBase'
import api from '../../api/checkout'

export default {
    mixins: [checkoutStepBase],

    data() {
        return {
            email: null,
            password: null,
            errors: {}
        }
    },

    methods: {
        async login() {
            try {
                const response = await api.login(this.email, this.password)

                this.refreshPage()
            } catch (exception) {
                const response = exception.response

                if (response && response.status === 422) {
                    this.errors = response.data.errors
                } else {
                    console.error('Login failure!', exception)
                }
            }
        },

        refreshPage() {
            window.location.reload()
        },
    }
}
